import { render, staticRenderFns } from "./EvaluationSkillGoalFilePage.vue?vue&type=template&id=a4d4713a&"
import script from "./EvaluationSkillGoalFilePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationSkillGoalFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports